import styled from "styled-components";

export const Button = styled.button<{fullWidth: boolean;}>`
  width: 100%;

  ${({ fullWidth }) => !fullWidth && `
    max-width: fit-content;
  `}
  height: fit-content;
  min-height: 55.61px;
  padding: 7px 35px 7px 20px;

  display: block;

  border: 0;
  border-radius: 30px;
  background-color: var(--blue00);
  color: #fff;
  cursor: pointer;
  transition: filter 0.2s;

  .icon-button__text{
    width: fit-content;
    max-width: 200px;
    margin-left: 22px;

    display: inline-block;

    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 1.25rem;

    @media (max-width: 768px) {
      margin-left: 16px;
      max-width: 140px;
    }
  }

  > svg {
    height: 55%;
    width: auto;
    max-width: 18px;

    vertical-align: middle;
    fill: #fff;
  }

  &:hover {
    filter: brightness(1.1);
  }
`
